import { Box, Rating } from "@mui/material";
import { useRatingStarsStyles } from "./RatingStars.style";

interface IProps {
	ratingValue: number | null;
	setRatingValue: (value: number) => void;
}

const RatingStars = ({ ratingValue, setRatingValue }: IProps) => {
	const { classes } = useRatingStarsStyles();

	return (
		<Box className={classes.buttonsWrapper}>
			<Rating
				size="large"
				name="reviews-rating-stars"
				defaultValue={0}
				value={ratingValue}
				onChange={(_, newValue) => newValue && setRatingValue(newValue)}
			/>
		</Box>
	);
};

export default RatingStars;
